import { render, staticRenderFns } from "./PaymentNotes.vue?vue&type=template&id=713b2d9f&scoped=true&"
import script from "./PaymentNotes.vue?vue&type=script&lang=js&"
export * from "./PaymentNotes.vue?vue&type=script&lang=js&"
import style0 from "./PaymentNotes.vue?vue&type=style&index=0&id=713b2d9f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713b2d9f",
  null
  
)

export default component.exports